import React from 'react';
import './TopBar.css';
import favicon from '../assets/favicon.png';
import NewsMarquee from './NewsMarquee';
import Clock from './Clock';
import NewsletterSignup from './NewsletterSignup';

export const TOP_BAR_HEIGHT = 56;

const TopBar = ({ onNewsClick }) =>
  <div className="top-bar" style={{ height: TOP_BAR_HEIGHT }}>
    <div className="os-icon">
      <img src={favicon} alt="2J" />
    </div>
    <NewsMarquee onClick={onNewsClick} />
    <NewsletterSignup />
    <Clock />
  </div>;

export default TopBar;
